import { useCallback } from 'react';
import { parseAsString, useQueryState } from 'nuqs';

import type { SortOption } from '../models';
import { useSortingOptions } from './use-sorting-options';

export const useProjectsControls = () => {
  const [sortParam, setSortParam] = useQueryState('sort', parseAsString.withDefault('date-newest'));
  const { data: sortOptions = [] } = useSortingOptions();

  const changeSort = useCallback(
    (option: SortOption | null) => {
      if (!option) {
        return;
      }
      setSortParam(option.id);
    },
    [setSortParam],
  );

  const createProject = useCallback(() => {
    console.log('Create project');
  }, []);

  return {
    changeSort,
    createProject,
    selectedSortOption: sortOptions.find((o) => o.id === sortParam),
    sortOptions,
  };
};
